/* eslint-disable */

import React, { useState, useEffect } from 'react';
import moment from 'moment';
import SiderComponent from './../components/SiderComponent';
import HeaderComponent from './../components/HeaderComponent';
import { formatedDealPeriodObject, refresh } from '../utils/Utils';
import { useSelector, useDispatch } from 'react-redux';
import { Tooltip } from 'antd';
import {
  setGolfClubDetails,
  setTmpCourseId,
  setTmpDealCourses,
  setNewDealCourses,
} from '../redux/actions/golfClubActions';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { DeleteFilled, SaveFilled } from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/de_DE';
import {
  Layout,
  Form,
  Input,
  Button,
  Row,
  Col,
  InputNumber,
  Select,
  Checkbox,
  Tree,
  DatePicker,
  notification,
  Popconfirm,
  Radio,
} from 'antd';
import greenfeeDealsApi from '../api/greenfeeDeals';
const { Content } = Layout;
const { RangePicker } = DatePicker;

function Sonstige(props) {
  // SESSION PARAMS
  const sessionBnd = localStorage.getItem('sessionBnd');
  const headers = {
    headers: { Authorization: `Bearer ${sessionBnd}` },
  };
  // REDUX STUFF
  const dispatch = useDispatch();
  const golfClubDetails = useSelector(
    (state) => state.golfClub.golfClubDetails,
  );
  const courses = useSelector((state) => state.golfClub.tmpDealCourses);
  const coursesNewDeal = useSelector((state) => state.golfClub.newDealCourses);
  const treeData = [];
  const treeDataNewDeal = [];
  let childrenNewDeal = [];
  golfClubDetails.courses.forEach((e) => {
    let subChildrenNewDeal = [];
    e.forEach((e2) => {
      subChildrenNewDeal.push({
        title: e2.standardPricing.dayFee
          ? `Tagesfee`
          : `${e2.standardPricing.numberHoles} Loch`,
        key: e2.standardPricing._id,
      });
    });
    childrenNewDeal.push({
      title: e[0].name,
      key: e[0]._id,
      children: subChildrenNewDeal,
    });
  });
  treeDataNewDeal.push({
    title: 'Plätze',
    key: 'group',
    children: childrenNewDeal,
  });
  let treeDataIndex = 0;
  // SAFETY
  if (!golfClubDetails) {
    props.history.push(`/`);
    return <div></div>;
  }

  // FORM STUFF
  const [form] = Form.useForm();
  const { Option } = Select;
  const { DirectoryTree } = Tree;
  const dateFormat = 'DD-MM-YY';
  let dateRange = '';
  const golfClubId = golfClubDetails._id.golfClub;

  // TREE STUFF
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedNewKeys, setCheckedNewKeys] = useState();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
    setAutoExpandParent(false);
  };

  const onCheckExisCourses = (keys, event) => {
    const filteredKeys = keys.filter((e) => e !== 'group');
    dispatch(setTmpDealCourses(filteredKeys));
  };
  const onCheckNewCourses = (keys, event) => {
    const filteredKeys = keys.filter((e) => e !== 'group');
    dispatch(setNewDealCourses(filteredKeys));
  };

  // UPDATE Deals
  const saveExisDeal = async (values) => {
    let deal = values.dealValues;
    console.log(deal);
    let amount = deal.discountAmount;

    if (amount) {
      amount = amount.toString().replace(',', '.');
    }

    // Optional: convert to number (recommended)
    amount = parseFloat(amount);

    if (deal.discountType === '%') {
      deal.discountPercent = amount;
      deal.discountPrice = '';
    } else {
      deal.discountPrice = amount;
      deal.discountPercent = '';
    }
    if (courses !== '') {
      deal.standardPricing = courses;
    }

    // if (values.dealPeriod) {
    //   const dealPeriod = formatedDealPeriodObject(values.dealPeriod);
    //   deal.dealPeriod = dealPeriod;
    // }
    if (values.dealPeriod && values.dealPeriod.length) {
      const dealPeriod = formatedDealPeriodObject(values.dealPeriod);
      deal.dealPeriod = dealPeriod;
    } else {
      deal.dealPeriod = null;
    }
    try {
      const updateDeal = await greenfeeDealsApi.patch(
        `/golfclubs/${golfClubId}/deals/${deal._id}`,
        deal,
        headers,
      );
      const golfClub = await greenfeeDealsApi.post(
        `/golfclubs/golfClubAdmin`,
        { id: golfClubId },
        headers,
      );
      if (golfClub.data.status !== 'success' || golfClub.data.results === 0) {
        return;
      }
      const results = golfClub.data.data.data;

      // Update Redux Store
      dispatch(setTmpDealCourses());
      dispatch(setGolfClubDetails(results));
      notification.success({
        message: 'Update Successful',
        description: 'The golf club details have been updated successfully.',
      });
      // refresh();
    } catch (error) {}
  };

  // New Deals
  const saveNewDeal = async (values) => {
    let newDeal = values.newDealValues;
    let amount = newDeal.discountAmount;

    if (amount) {
      amount = amount.toString().replace(',', '.');
    }

    // Optional: convert to number (recommended)
    amount = parseFloat(amount);

    if (newDeal.discountType === '%') {
      newDeal.discountPercent = amount;
    } else {
      newDeal.discountPrice = amount;
    }
    if (checkedNewKeys === undefined || checkedNewKeys[0] === 'group') {
      let newCourses = [];
      golfClubDetails.courses.forEach((e) => {
        newCourses.push(e[0]._id);
      });
      golfClubDetails.standardPricing.forEach((e2) => {
        newCourses.push(e2._id);
      });

      newDeal.standardPricing = newCourses;
    } else {
      newDeal.standardPricing = checkedNewKeys;
    }

    const dealPeriod = formatedDealPeriodObject(values.newDealPeriod);
    newDeal.dealPeriod = dealPeriod;

    newDeal.dealDetails = {
      type: 'special',
    };

    try {
      const postDeal = await greenfeeDealsApi.post(
        `/golfclubs/${golfClubId}/deals`,
        newDeal,
        headers,
      );
      const golfClub = await greenfeeDealsApi.post(
        `/golfclubs/golfClubAdmin`,
        { id: golfClubId },
        headers,
      );
      if (golfClub.data.status !== 'success' || golfClub.data.results === 0) {
        return;
      }
      const results = golfClub.data.data.data;

      // Update Redux Store
      dispatch(setGolfClubDetails(results));
      form.resetFields();
      setCheckedNewKeys(['group']);
      notification.success({
        message: 'New Deal Save Successfully',
        description: 'The golf club new deal have been saved successfully.',
      });
    } catch (error) {}
  };

  //DELETE deal
  const deleteDeal = async (dealId) => {
    try {
      const postDeal = await greenfeeDealsApi.delete(
        `/golfclubs/${golfClubId}/deals/${dealId}`,
        headers,
      );
      const golfClub = await greenfeeDealsApi.post(
        `/golfclubs/golfClubAdmin`,
        { id: golfClubId },
        headers,
      );
      if (golfClub.data.status !== 'success' || golfClub.data.results === 0) {
        return;
      }
      const results = golfClub.data.data.data;

      // Update Redux Store
      dispatch(setGolfClubDetails(results));
      notification.success({
        message: 'Deleted Deal Successfully',
        description: 'The golf club deal have been deleted successfully.',
      });
      //window.location.reload(false);
    } catch (error) {}
  };
  useEffect(() => {
    setCheckedNewKeys(['group']);
    dispatch(setTmpDealCourses());
  }, []);

  const cancel = (e) => {
    console.log(e);
  };

  return (
    <div>
      <Layout style={{ minHeight: '100vh' }}>
        <SiderComponent props={props} />
        <Layout>
          <HeaderComponent />
          <Content
            style={{
              backgroundColor: '#EAEAEA',
              paddingLeft: 50,
              paddingRight: 50,
              paddingBottom: 50,
            }}
          >
            <h3 style={{ marginTop: 30, marginBottom: 0 }}>
              Early Bird & Sundowner
            </h3>
            <h5 style={{ fontSize: 14 }}>
              Hier können Sie Tarife für frühe/späte Startzeiten definieren.
              Zeitbeschränkungen bitte im Feld “Anmerkungen” angeben. Z.B. "bis
              8 Uhr" (Early Bird) oder “ab 16:30 Uhr” (Sundowner)
            </h5>
            <p style={{ color: '#ff0404', fontSize: 14 }}>
              (Achtung: Prozentuale Rabatte (%), Abzüge (-) oder Aufschläge (+)
              beziehen sich immer auf das Greenfee, das unter Stammdaten für
              DGV-R-Golfer angegeben wurde.)
            </p>
            <div>
              <div
                style={{
                  backgroundColor: 'white',
                  borderRadius: 15,
                  width: '100%',
                  padding: 30,
                  marginTop: 20,
                }}
              >
                <h5 className="Form-heading">Neuen Deal anlegen</h5>
                <Form
                  onFinish={saveNewDeal}
                  hideRequiredMark
                  form={form}
                  initialValues={{
                    newDealValues: {
                      dealDays: {
                        0: 'true',
                        1: 'true',
                        2: 'true',
                        3: 'true',
                        4: 'true',
                        5: 'true',
                        6: 'true',
                      },
                      discountType: '%',
                    },
                  }}
                  className="create-top-deals-form"
                  style={{ marginTop: 20 }}
                >
                  <Row>
                    <Col span={24}>
                      <Row style={{ gap: 10 }}>
                        <Col style={{ width: 180 }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 10,
                            }}
                          >
                            <label
                              style={{
                                fontSize: 13,
                                color: '#222222',
                                fontWeight: 500,
                                display: 'block',
                              }}
                            >
                              Typ
                            </label>
                          </div>
                          <Form.Item name={['newDealValues', 'name']}>
                            <Select size="small">
                              <Option value="Early Bird">Early Bird</Option>
                              <Option value="Sundowner">Sundowner</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Row style={{ gap: 10, alignItems: 'end' }}>
                            <div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'flex-start',
                                  gap: 6,
                                }}
                              >
                                <label
                                  style={{
                                    fontSize: 13,
                                    color: '#222222',
                                    fontWeight: 500,
                                    display: 'block',
                                  }}
                                >
                                  Art
                                </label>
                                <Tooltip
                                  title={
                                    <div>
                                      <div>„€“ = Preis festlegen</div>
                                      <div>
                                        „%“ = relativer Rabatt vom Normaltarif
                                        (DGV-Gold)
                                      </div>
                                      <div>
                                        „-“ = Preisabzug vom Normaltarif
                                        (DGV-Gold)
                                      </div>
                                      <div>
                                        „+“ = Preisaufschlag vom Normaltarif
                                        (DGV-Gold)
                                      </div>
                                    </div>
                                  }
                                >
                                  <svg
                                    width="11"
                                    height="11"
                                    viewBox="0 0 11 11"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle
                                      cx="5.40039"
                                      cy="5.4"
                                      r="5"
                                      stroke="#628478"
                                      strokeWidth="0.8"
                                    />
                                    <path
                                      d="M6.59513 3.35132C6.53772 3.41147 6.47109 3.46211 6.39776 3.50132C6.3247 3.53798 6.24595 3.562 6.16486 3.57237C6.0833 3.58026 6.00564 3.56709 5.93197 3.53289C5.86092 3.49869 5.79909 3.45 5.74644 3.38684C5.6333 3.25525 5.57671 3.12237 5.57671 2.98816C5.57671 2.85395 5.59777 2.75394 5.63986 2.68816C5.68461 2.61973 5.73987 2.56446 5.80565 2.52237C5.93197 2.4408 6.05039 2.4 6.16092 2.4C6.27406 2.4 6.36091 2.40789 6.42144 2.42368C6.4846 2.43947 6.54249 2.46578 6.59513 2.50263C6.72406 2.58947 6.78855 2.69605 6.78855 2.82237C6.78855 2.94606 6.77014 3.04999 6.73329 3.13421C6.69909 3.21578 6.65301 3.28816 6.59513 3.35132ZM5.78592 7.62237C5.85435 7.62237 5.88855 7.66712 5.88855 7.75658C5.88855 7.875 5.83461 7.99737 5.72671 8.12368C5.56881 8.30788 5.35698 8.4 5.09118 8.4C4.78591 8.4 4.5767 8.2763 4.46355 8.02895C4.42145 7.9421 4.40039 7.83685 4.40039 7.71316C4.40039 7.58946 4.42145 7.45263 4.46355 7.30263C4.5083 7.15001 4.56223 6.99079 4.62539 6.825C4.69242 6.65361 4.76349 6.48382 4.83855 6.31579L5.04776 5.81842C5.20038 5.44737 5.27671 5.20263 5.27671 5.08421C5.27671 4.96579 5.26354 4.88817 5.23723 4.85132C5.21355 4.81184 5.18724 4.78159 5.15829 4.76053L5.07934 4.70526C5.05303 4.68685 5.03986 4.65527 5.03986 4.61053C5.03986 4.56316 5.05698 4.51841 5.09118 4.47632C5.12803 4.43422 5.1754 4.39737 5.23329 4.36579C5.35171 4.30525 5.48986 4.275 5.64776 4.275C6.0346 4.275 6.22802 4.3763 6.22802 4.57895C6.22802 4.81579 6.16619 5.08683 6.0425 5.3921C5.9188 5.69473 5.81355 5.93946 5.72671 6.12632L5.48986 6.67105C5.31618 7.07106 5.22934 7.35922 5.22934 7.53553C5.22934 7.65133 5.28722 7.70921 5.40302 7.70921C5.51617 7.70921 5.60172 7.69475 5.6596 7.66579C5.71749 7.63683 5.75961 7.62237 5.78592 7.62237Z"
                                      fill="#628478"
                                      stroke="#628478"
                                      strokeWidth="0.3"
                                    />
                                  </svg>
                                </Tooltip>
                              </div>
                              <Form.Item
                                name={['newDealValues', 'discountType']}
                              >
                                <Select size="small" style={{ width: 65 }}>
                                  <Option value="%">%</Option>
                                  <Option value="€">€</Option>
                                  <Option value="-">-</Option>
                                  <Option value="+">+</Option>
                                </Select>
                              </Form.Item>
                            </div>

                            <Form.Item
                              name={['newDealValues', 'discountAmount']}
                            >
                              <Input
                                size="small"
                                style={{ width: 165 }}
                                onChange={(e) => {
                                  let value = e.target.value;

                                  // Replace dot with comma instantly
                                  value = value.replace('.', ',');

                                  // Optional: prevent multiple commas
                                  const parts = value.split(',');
                                  if (parts.length > 2) {
                                    value =
                                      parts[0] + ',' + parts.slice(1).join('');
                                  }

                                  // Update form value manually
                                  form.setFieldsValue({
                                    newDealValues: {
                                      discountAmount: value,
                                    },
                                  });
                                }}
                              />
                            </Form.Item>
                          </Row>
                        </Col>
                        <Col span={8}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 10,
                            }}
                          >
                            <label
                              style={{
                                fontSize: 13,
                                color: '#222222',
                                fontWeight: 500,
                                display: 'block',
                              }}
                            >
                              Tage auswählen
                            </label>
                          </div>
                          <Row style={{ gap: 10 }}>
                            <Col span={2} className="pricingCol" align="center">
                              <Form.Item
                                name={['newDealValues', 'dealDays', 0]}
                                valuePropName="checked"
                              >
                                <Checkbox className="bigCheck checkbox-col">
                                  <h6 style={{ display: 'inline' }}>M</h6>
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={2} className="pricingCol" align="center">
                              <Form.Item
                                name={['newDealValues', 'dealDays', 1]}
                                valuePropName="checked"
                              >
                                <Checkbox className="bigCheck checkbox-col">
                                  <h6 style={{ display: 'inline' }}>D</h6>
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={2} className="pricingCol" align="center">
                              <Form.Item
                                name={['newDealValues', 'dealDays', 2]}
                                valuePropName="checked"
                              >
                                <Checkbox className="bigCheck checkbox-col">
                                  <h6 style={{ display: 'inline' }}>M</h6>
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={2} className="pricingCol" align="center">
                              <Form.Item
                                name={['newDealValues', 'dealDays', 3]}
                                valuePropName="checked"
                              >
                                <Checkbox className="bigCheck checkbox-col">
                                  <h6 style={{ display: 'inline' }}>D</h6>
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={2} className="pricingCol" align="center">
                              <Form.Item
                                name={['newDealValues', 'dealDays', 4]}
                                valuePropName="checked"
                              >
                                <Checkbox className="bigCheck checkbox-col">
                                  <h6 style={{ display: 'inline' }}>F</h6>
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={2} className="pricingCol" align="center">
                              <Form.Item
                                name={['newDealValues', 'dealDays', 5]}
                                valuePropName="checked"
                              >
                                <Checkbox className="bigCheck checkbox-col">
                                  <h6 style={{ display: 'inline' }}>S</h6>
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={2} className="pricingCol" align="center">
                              <Form.Item
                                name={['newDealValues', 'dealDays', 6]}
                                valuePropName="checked"
                              >
                                <Checkbox className="bigCheck checkbox-col">
                                  <h6 style={{ display: 'inline' }}>S</h6>
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={4}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 10,
                              marginBottom: 8,
                            }}
                          >
                            <label
                              style={{
                                fontSize: 13,
                                color: '#222222',
                                fontWeight: 500,
                                margin: 0,
                              }}
                            >
                              Anmerkung
                            </label>

                            <Tooltip title="Fügen Sie eine zusätzliche Notiz zu diesem Geschäft hinzu.">
                              <svg
                                width="11"
                                height="11"
                                viewBox="0 0 11 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle
                                  cx="5.40039"
                                  cy="5.4"
                                  r="5"
                                  stroke="#628478"
                                  strokeWidth="0.8"
                                />
                                <path
                                  d="M6.59513 3.35132C6.53772 3.41147 6.47109 3.46211 6.39776 3.50132C6.3247 3.53798 6.24595 3.562 6.16486 3.57237C6.0833 3.58026 6.00564 3.56709 5.93197 3.53289C5.86092 3.49869 5.79909 3.45 5.74644 3.38684C5.6333 3.25525 5.57671 3.12237 5.57671 2.98816C5.57671 2.85395 5.59777 2.75394 5.63986 2.68816C5.68461 2.61973 5.73987 2.56446 5.80565 2.52237C5.93197 2.4408 6.05039 2.4 6.16092 2.4C6.27406 2.4 6.36091 2.40789 6.42144 2.42368C6.4846 2.43947 6.54249 2.46578 6.59513 2.50263C6.72406 2.58947 6.78855 2.69605 6.78855 2.82237C6.78855 2.94606 6.77014 3.04999 6.73329 3.13421C6.69909 3.21578 6.65301 3.28816 6.59513 3.35132ZM5.78592 7.62237C5.85435 7.62237 5.88855 7.66712 5.88855 7.75658C5.88855 7.875 5.83461 7.99737 5.72671 8.12368C5.56881 8.30788 5.35698 8.4 5.09118 8.4C4.78591 8.4 4.5767 8.2763 4.46355 8.02895C4.42145 7.9421 4.40039 7.83685 4.40039 7.71316C4.40039 7.58946 4.42145 7.45263 4.46355 7.30263C4.5083 7.15001 4.56223 6.99079 4.62539 6.825C4.69242 6.65361 4.76349 6.48382 4.83855 6.31579L5.04776 5.81842C5.20038 5.44737 5.27671 5.20263 5.27671 5.08421C5.27671 4.96579 5.26354 4.88817 5.23723 4.85132C5.21355 4.81184 5.18724 4.78159 5.15829 4.76053L5.07934 4.70526C5.05303 4.68685 5.03986 4.65527 5.03986 4.61053C5.03986 4.56316 5.05698 4.51841 5.09118 4.47632C5.12803 4.43422 5.1754 4.39737 5.23329 4.36579C5.35171 4.30525 5.48986 4.275 5.64776 4.275C6.0346 4.275 6.22802 4.3763 6.22802 4.57895C6.22802 4.81579 6.16619 5.08683 6.0425 5.3921C5.9188 5.69473 5.81355 5.93946 5.72671 6.12632L5.48986 6.67105C5.31618 7.07106 5.22934 7.35922 5.22934 7.53553C5.22934 7.65133 5.28722 7.70921 5.40302 7.70921C5.51617 7.70921 5.60172 7.69475 5.6596 7.66579C5.71749 7.63683 5.75961 7.62237 5.78592 7.62237Z"
                                  fill="#628478"
                                  stroke="#628478"
                                  strokeWidth="0.3"
                                />
                              </svg>
                            </Tooltip>
                          </div>

                          <Form.Item name={['newDealValues', 'discountTerms']}>
                            <Input size="small" placeholder="Anmerkung" />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row
                        style={{ marginBlock: 15, gap: 10, alignItems: 'end' }}
                      >
                        <Col span={10}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 10,
                            }}
                          >
                            <label
                              style={{
                                fontSize: 13,
                                color: '#595959',
                                fontWeight: 500,
                                display: 'block',
                                width: '100%',
                              }}
                            >
                              Hier können Sie Deals zeitlich beschränken.
                              Freilassen, wenn dauerhaft gültig
                            </label>
                          </div>
                          <Form.Item name={['newDealPeriod']}>
                            <RangePicker
                              allowClear={false}
                              size="small"
                              format={dateFormat}
                              locale={locale}
                              style={{ width: '100%' }}
                              className="picker-design-styl"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={3}>
                          <Form.Item
                            name={['newDealValues', 'rollingDeal']}
                            valuePropName="checked"
                            style={{ marginLeft: 10 }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 6,
                              }}
                            >
                              <Checkbox className="bigCheck">
                                <span>Rolling</span>
                              </Checkbox>

                              <Tooltip title="auswahlen wenn sich der Zeitraum jahrlich wiederholt.">
                                <svg
                                  width="11"
                                  height="11"
                                  viewBox="0 0 11 11"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <circle
                                    cx="5.40039"
                                    cy="5.4"
                                    r="5"
                                    stroke="#628478"
                                    strokeWidth="0.8"
                                  />
                                  <path
                                    d="M6.59513 3.35132C6.53772 3.41147 6.47109 3.46211 6.39776 3.50132C6.3247 3.53798 6.24595 3.562 6.16486 3.57237C6.0833 3.58026 6.00564 3.56709 5.93197 3.53289C5.86092 3.49869 5.79909 3.45 5.74644 3.38684C5.6333 3.25525 5.57671 3.12237 5.57671 2.98816C5.57671 2.85395 5.59777 2.75394 5.63986 2.68816C5.68461 2.61973 5.73987 2.56446 5.80565 2.52237C5.93197 2.4408 6.05039 2.4 6.16092 2.4C6.27406 2.4 6.36091 2.40789 6.42144 2.42368C6.4846 2.43947 6.54249 2.46578 6.59513 2.50263C6.72406 2.58947 6.78855 2.69605 6.78855 2.82237C6.78855 2.94606 6.77014 3.04999 6.73329 3.13421C6.69909 3.21578 6.65301 3.28816 6.59513 3.35132ZM5.78592 7.62237C5.85435 7.62237 5.88855 7.66712 5.88855 7.75658C5.88855 7.875 5.83461 7.99737 5.72671 8.12368C5.56881 8.30788 5.35698 8.4 5.09118 8.4C4.78591 8.4 4.5767 8.2763 4.46355 8.02895C4.42145 7.9421 4.40039 7.83685 4.40039 7.71316C4.40039 7.58946 4.42145 7.45263 4.46355 7.30263C4.5083 7.15001 4.56223 6.99079 4.62539 6.825C4.69242 6.65361 4.76349 6.48382 4.83855 6.31579L5.04776 5.81842C5.20038 5.44737 5.27671 5.20263 5.27671 5.08421C5.27671 4.96579 5.26354 4.88817 5.23723 4.85132C5.21355 4.81184 5.18724 4.78159 5.15829 4.76053L5.07934 4.70526C5.05303 4.68685 5.03986 4.65527 5.03986 4.61053C5.03986 4.56316 5.05698 4.51841 5.09118 4.47632C5.12803 4.43422 5.1754 4.39737 5.23329 4.36579C5.35171 4.30525 5.48986 4.275 5.64776 4.275C6.0346 4.275 6.22802 4.3763 6.22802 4.57895C6.22802 4.81579 6.16619 5.08683 6.0425 5.3921C5.9188 5.69473 5.81355 5.93946 5.72671 6.12632L5.48986 6.67105C5.31618 7.07106 5.22934 7.35922 5.22934 7.53553C5.22934 7.65133 5.28722 7.70921 5.40302 7.70921C5.51617 7.70921 5.60172 7.69475 5.6596 7.66579C5.71749 7.63683 5.75961 7.62237 5.78592 7.62237Z"
                                    fill="#628478"
                                    stroke="#628478"
                                    strokeWidth="0.3"
                                  />
                                </svg>
                              </Tooltip>
                            </div>
                          </Form.Item>
                        </Col>
                        <Col span={10}>
                          <DirectoryTree
                            checkable
                            selectable={false}
                            multiple
                            showIcon={false}
                            onCheck={(keys) => {
                              setCheckedNewKeys(keys);
                            }}
                            onExpand={onExpand}
                            treeData={treeDataNewDeal}
                            checkedKeys={checkedNewKeys}
                          />
                        </Col>
                      </Row>
                    </Col>
                    {/* <Col span={8} className="pricingCol">
                    <Row
                      align="center"
                      style={{
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      
                    </Row>
                  </Col> */}
                    {/* <Col span={5} className="pricingCol">
                    <Row>
                      
                    </Row>
                    <Row>
                     
                    </Row>
                  </Col>
                  <Col span={4} className="pricingCol">
                    <Row
                      style={{
                        alignItems: 'center',
                        height: '100%',
                      }}
                    >
                      <Col
                        span={20}
                        style={{
                          height: '100%',
                        }}
                      >
                        <Row
                          style={{
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                          }}
                        >
                         
                        </Row>
                      </Col>

                      <Col span={4}></Col>
                    </Row>
                  </Col> */}
                  </Row>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      backgroundColor: '#1B392F',
                      borderColor: '#1F4D3D',
                      minWidth: 90,
                      height: 44,
                      fontSize: 15,
                      fontWeight: 500,
                      borderRadius: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 8,
                      marginInlineStart: 'auto',
                    }}
                  >
                    Speichern
                  </Button>
                </Form>
              </div>
              {/* <hr
          style={{
            border: "0.3px dotted rgba(0, 0, 0, 0.85)",
            marginTop: 30,
          }}
        /> */}
              <div
                style={{
                  backgroundColor: 'white',
                  borderRadius: 15,
                  width: '100%',
                  padding: 30,
                  marginTop: 20,
                }}
              >
                <h5 className="Form-heading">Bestehende Deals editieren</h5>
                {[...golfClubDetails.deals]
                  .filter(
                    (deal) =>
                      deal.dealDetails.type === 'special' &&
                      (deal.name === 'Early Bird' || deal.name === 'Sundowner'),
                  )
                  .sort((a, b) =>
                    (a.name || '').localeCompare(b.name || '', 'de', {
                      sensitivity: 'base',
                    }),
                  )
                  .map((deal, index) => {
                    if (
                      deal.dealDetails.type === 'special' &&
                      (deal.name === 'Early Bird' || deal.name === 'Sundowner')
                    ) {
                      if (deal.discountPercent) {
                        deal.discountType = '%';
                        deal.discountAmount = deal.discountPercent;
                      } else {
                        if (!deal.discountType) {
                          deal.discountType = '€';
                          deal.discountAmount = deal.discountPrice;
                        } else {
                          deal.discountAmount = deal.discountPrice;
                        }
                      }
                      if (
                        deal.discountAmount &&
                        deal.discountAmount.toString().includes('.')
                      ) {
                        deal.discountAmount = deal.discountAmount
                          .toFixed(2)
                          .replace('.', ',');
                      }
                      let dealPeriod = [];
                      if (deal.dealPeriod) {
                        dealPeriod = [
                          moment(deal.dealPeriod?.from),
                          moment(deal.dealPeriod?.to),
                        ];
                      }
                      let children = [];
                      golfClubDetails.courses.forEach((e) => {
                        let subChildren = [];
                        e.forEach((e2) => {
                          subChildren.push({
                            title: e2.standardPricing.dayFee
                              ? `Tagesfee`
                              : `${e2.standardPricing.numberHoles} Loch`,
                            key: e2.standardPricing._id,
                          });
                        });
                        children.push({
                          title: e[0].name,
                          key: e[0]._id,
                          children: subChildren,
                        });
                      });

                      treeData.push([
                        {
                          title: 'Plätze',
                          key: 'group',
                          children: children,
                        },
                      ]);
                      const treeDataMap = treeData[treeDataIndex];
                      treeDataIndex++;

                      return (
                        <Form
                          key={deal._id}
                          onFinish={saveExisDeal}
                          hideRequiredMark
                          initialValues={{
                            dealValues: {
                              ...deal,
                              rollingDeal:
                                deal.rollingDeal === true ||
                                deal.rollingDeal === 'true',
                            },
                            dealPeriod: dealPeriod,
                          }}
                          className="create-top-deals-form form-bg-change-style"
                        >
                          <Form.Item
                            name={['dealValues', '_id']}
                            className="noHeight"
                          >
                            <span />
                          </Form.Item>

                          {/* <Row>
                    <Col span={7}>
                      <Row>
                        <Col style={{ width: 180 }}>
                          <Form.Item name={["dealValues", "name"]}>
                            <Select size="small">
                              <Option value="Early Bird">Early Bird</Option>
                              <Option value="Sundowner">Sundowner</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col style={{ width: 50 }}>
                          <Form.Item name={["dealValues", "discountType"]}>
                            <Select defaultValue="%" size="small">
                              <Option value="%">%</Option>
                              <Option value="€">€</Option>
                              <Option value="-">-</Option>
                              <Option value="+">+</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item name={["dealValues", "discountAmount"]}>
                            <InputNumber size="small" style={{ width: 65 }} />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Form.Item name={["dealPeriod"]}>
                          <RangePicker
                            allowClear={false}
                            size="small"
                            format={dateFormat}
                            locale={locale}
                            defaultValue={dealPeriod}
                            style={{ width: 275 }}
                          />
                        </Form.Item>
                        <Form.Item
                          name={["dealValues", "rollingDeal"]}
                          valuePropName="checked"
                          style={{ width: 30, marginLeft: 10 }}
                        >
                          <Checkbox className="bigCheck">
                            <h6 style={{ display: "inline" }}>Rolling</h6>
                          </Checkbox>
                        </Form.Item>
                      </Row>
                    </Col>
                    <Col span={8} className="pricingCol">
                      <Row
                        align="center"
                        style={{
                          height: "100%",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Col span={2} className="pricingCol" align="center">
                          <Form.Item
                            name={["dealValues", "dealDays", 0]}
                            valuePropName="checked"
                          >
                            <Checkbox className="bigCheck">
                              <h6 style={{ display: "inline" }}>Mo</h6>
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={2} className="pricingCol" align="center">
                          <Form.Item
                            name={["dealValues", "dealDays", 1]}
                            valuePropName="checked"
                          >
                            <Checkbox className="bigCheck">
                              <h6 style={{ display: "inline" }}>Di</h6>
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={2} className="pricingCol" align="center">
                          <Form.Item
                            name={["dealValues", "dealDays", 2]}
                            valuePropName="checked"
                          >
                            <Checkbox className="bigCheck">
                              <h6 style={{ display: "inline" }}>Mi</h6>
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={2} className="pricingCol" align="center">
                          <Form.Item
                            name={["dealValues", "dealDays", 3]}
                            valuePropName="checked"
                          >
                            <Checkbox className="bigCheck">
                              <h6 style={{ display: "inline" }}>Do</h6>
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={2} className="pricingCol" align="center">
                          <Form.Item
                            name={["dealValues", "dealDays", 4]}
                            valuePropName="checked"
                          >
                            <Checkbox className="bigCheck">
                              <h6 style={{ display: "inline" }}>Fr</h6>
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={2} className="pricingCol" align="center">
                          <Form.Item
                            name={["dealValues", "dealDays", 5]}
                            valuePropName="checked"
                          >
                            <Checkbox className="bigCheck">
                              <h6 style={{ display: "inline" }}>Sa</h6>
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={2} className="pricingCol" align="center">
                          <Form.Item
                            name={["dealValues", "dealDays", 6]}
                            valuePropName="checked"
                          >
                            <Checkbox className="bigCheck">
                              <h6 style={{ display: "inline" }}>So/Ft</h6>
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={5} className="pricingCol">
                      <Row>
                        <Col span={24} className="pricingCol">
                          <Form.Item
                            name={["dealValues", "discountTerms"]}
                            id={index}
                          >
                            <Input size="small" placeholder="Anmerkung" />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <DirectoryTree
                          checkable
                          selectable={false}
                          multiple
                          showIcon={false}
                          onCheck={(keys) => {
                            dispatch(setTmpCourseId(deal._id));
                            onCheckExisCourses(keys);
                          }}
                          onExpand={onExpand}
                          treeData={treeDataMap}
                          defaultCheckedKeys={deal.standardPricing}
                        />
                      </Row>
                    </Col>
                    <Col span={4} className="pricingCol">
                      <Row
                        style={{
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Col
                          span={20}
                          style={{
                            height: "100%",
                          }}
                        >
                          <Row
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                              height: "100%",
                            }}
                          >
                            <Button
                              type="primary"
                              htmlType="submit"
                              style={{
                                minWidth: 85,
                                minHeight: 40,
                              }}
                            >
                              Speichern
                            </Button>
                          </Row>
                        </Col>

                        <Col span={4}>
                          <Popconfirm
                            title="Löschen Sie den Deal"
                            description="Wirklich löschen?"
                            icon={
                              <QuestionCircleOutlined
                                style={{
                                  color: "red",
                                }}
                              />
                            }
                            onConfirm={() => deleteDeal(deal._id)}
                            onCancel={cancel}
                            okText="Bestätigen"
                            cancelText="Abbrechen"
                          >
                            <Button
                              danger
                              type="primary"
                              icon={<DeleteFilled />}
                              size="small"
                            />
                          </Popconfirm>
                        </Col>
                      </Row>
                    </Col>
                  </Row> */}
                          <Row>
                            <Col span={24}>
                              <Row style={{ gap: 10 }}>
                                <Col style={{ width: 180 }}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 10,
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontSize: 13,
                                        color: '#222222',
                                        fontWeight: 500,
                                        display: 'block',
                                      }}
                                    >
                                      Typ
                                    </label>
                                  </div>

                                  <Form.Item name={['dealValues', 'name']}>
                                    <Select size="small">
                                      <Option value="Early Bird">
                                        Early Bird
                                      </Option>
                                      <Option value="Sundowner">
                                        Sundowner
                                      </Option>
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={6}>
                                  <Row style={{ gap: 10, alignItems: 'end' }}>
                                    <div>
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: 10,
                                        }}
                                      >
                                        <label
                                          style={{
                                            fontSize: 13,
                                            color: '#222222',
                                            fontWeight: 500,
                                            display: 'block',
                                          }}
                                        >
                                          Art
                                        </label>
                                      </div>
                                      <Form.Item
                                        name={['dealValues', 'discountType']}
                                      >
                                        <Select
                                          size="small"
                                          defaultValue={'%'}
                                          style={{ width: 65 }}
                                        >
                                          <Option value="%">%</Option>
                                          <Option value="€">€</Option>
                                          <Option value="-">-</Option>
                                          <Option value="+">+</Option>
                                        </Select>
                                      </Form.Item>
                                    </div>
                                    <Form.Item
                                      className="custom-deal-amount"
                                      name={['dealValues', 'discountAmount']}
                                      getValueFromEvent={(e) => {
                                        let val = e.target.value;

                                        val = val.replace(/[^0-9.,]/g, '');
                                        val = val.replace(/\./g, ',');

                                        return val;
                                      }}
                                    >
                                      <Input
                                        size="small"
                                        style={{ width: 165 }}
                                      />
                                    </Form.Item>
                                  </Row>
                                </Col>
                                <Col span={8}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 10,
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontSize: 13,
                                        color: '#222222',
                                        fontWeight: 500,
                                        display: 'block',
                                      }}
                                    >
                                      Tage auswählen
                                    </label>
                                  </div>
                                  <Row style={{ gap: 10 }}>
                                    <Col
                                      span={2}
                                      className="pricingCol"
                                      align="center"
                                    >
                                      <Form.Item
                                        name={['dealValues', 'dealDays', 0]}
                                        valuePropName="checked"
                                      >
                                        <Checkbox className="bigCheck checkbox-col">
                                          <h6 style={{ display: 'inline' }}>
                                            M
                                          </h6>
                                        </Checkbox>
                                      </Form.Item>
                                    </Col>
                                    <Col
                                      span={2}
                                      className="pricingCol"
                                      align="center"
                                    >
                                      <Form.Item
                                        name={['dealValues', 'dealDays', 1]}
                                        valuePropName="checked"
                                      >
                                        <Checkbox className="bigCheck checkbox-col">
                                          <h6 style={{ display: 'inline' }}>
                                            D
                                          </h6>
                                        </Checkbox>
                                      </Form.Item>
                                    </Col>
                                    <Col
                                      span={2}
                                      className="pricingCol"
                                      align="center"
                                    >
                                      <Form.Item
                                        name={['dealValues', 'dealDays', 2]}
                                        valuePropName="checked"
                                      >
                                        <Checkbox className="bigCheck checkbox-col">
                                          <h6 style={{ display: 'inline' }}>
                                            M
                                          </h6>
                                        </Checkbox>
                                      </Form.Item>
                                    </Col>
                                    <Col
                                      span={2}
                                      className="pricingCol"
                                      align="center"
                                    >
                                      <Form.Item
                                        name={['dealValues', 'dealDays', 3]}
                                        valuePropName="checked"
                                      >
                                        <Checkbox className="bigCheck checkbox-col">
                                          <h6 style={{ display: 'inline' }}>
                                            D
                                          </h6>
                                        </Checkbox>
                                      </Form.Item>
                                    </Col>
                                    <Col
                                      span={2}
                                      className="pricingCol"
                                      align="center"
                                    >
                                      <Form.Item
                                        name={['dealValues', 'dealDays', 4]}
                                        valuePropName="checked"
                                      >
                                        <Checkbox className="bigCheck checkbox-col">
                                          <h6 style={{ display: 'inline' }}>
                                            F
                                          </h6>
                                        </Checkbox>
                                      </Form.Item>
                                    </Col>
                                    <Col
                                      span={2}
                                      className="pricingCol"
                                      align="center"
                                    >
                                      <Form.Item
                                        name={['dealValues', 'dealDays', 5]}
                                        valuePropName="checked"
                                      >
                                        <Checkbox className="bigCheck checkbox-col">
                                          <h6 style={{ display: 'inline' }}>
                                            S
                                          </h6>
                                        </Checkbox>
                                      </Form.Item>
                                    </Col>
                                    <Col
                                      span={2}
                                      className="pricingCol"
                                      align="center"
                                    >
                                      <Form.Item
                                        name={['dealValues', 'dealDays', 6]}
                                        valuePropName="checked"
                                      >
                                        <Checkbox className="bigCheck checkbox-col">
                                          <h6 style={{ display: 'inline' }}>
                                            S
                                          </h6>
                                        </Checkbox>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col span={4} className="pricingCol">
                                  <Form.Item
                                    className="custom-label-fix"
                                    name={['dealValues', 'discountTerms']}
                                    initialValue={deal?.discountTerms}
                                    label={
                                      <span
                                        style={{
                                          fontSize: 13,
                                          fontWeight: 500,
                                        }}
                                      >
                                        Anmerkung
                                        <span
                                          style={{
                                            marginLeft: 8,
                                          }}
                                        >
                                          <Tooltip title="Fügen Sie eine zusätzliche Notiz zu diesem Geschäft hinzu.">
                                            <svg
                                              width="11"
                                              height="11"
                                              viewBox="0 0 11 11"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <circle
                                                cx="5.40039"
                                                cy="5.4"
                                                r="5"
                                                stroke="#628478"
                                                strokeWidth="0.8"
                                              />
                                              <path
                                                d="M6.59513 3.35132C6.53772 3.41147 6.47109 3.46211 6.39776 3.50132C6.3247 3.53798 6.24595 3.562 6.16486 3.57237C6.0833 3.58026 6.00564 3.56709 5.93197 3.53289C5.86092 3.49869 5.79909 3.45 5.74644 3.38684C5.6333 3.25525 5.57671 3.12237 5.57671 2.98816C5.57671 2.85395 5.59777 2.75394 5.63986 2.68816C5.68461 2.61973 5.73987 2.56446 5.80565 2.52237C5.93197 2.4408 6.05039 2.4 6.16092 2.4C6.27406 2.4 6.36091 2.40789 6.42144 2.42368C6.4846 2.43947 6.54249 2.46578 6.59513 2.50263C6.72406 2.58947 6.78855 2.69605 6.78855 2.82237C6.78855 2.94606 6.77014 3.04999 6.73329 3.13421C6.69909 3.21578 6.65301 3.28816 6.59513 3.35132ZM5.78592 7.62237C5.85435 7.62237 5.88855 7.66712 5.88855 7.75658C5.88855 7.875 5.83461 7.99737 5.72671 8.12368C5.56881 8.30788 5.35698 8.4 5.09118 8.4C4.78591 8.4 4.5767 8.2763 4.46355 8.02895C4.42145 7.9421 4.40039 7.83685 4.40039 7.71316C4.40039 7.58946 4.42145 7.45263 4.46355 7.30263C4.5083 7.15001 4.56223 6.99079 4.62539 6.825C4.69242 6.65361 4.76349 6.48382 4.83855 6.31579L5.04776 5.81842C5.20038 5.44737 5.27671 5.20263 5.27671 5.08421C5.27671 4.96579 5.26354 4.88817 5.23723 4.85132C5.21355 4.81184 5.18724 4.78159 5.15829 4.76053L5.07934 4.70526C5.05303 4.68685 5.03986 4.65527 5.03986 4.61053C5.03986 4.56316 5.05698 4.51841 5.09118 4.47632C5.12803 4.43422 5.1754 4.39737 5.23329 4.36579C5.35171 4.30525 5.48986 4.275 5.64776 4.275C6.0346 4.275 6.22802 4.3763 6.22802 4.57895C6.22802 4.81579 6.16619 5.08683 6.0425 5.3921C5.9188 5.69473 5.81355 5.93946 5.72671 6.12632L5.48986 6.67105C5.31618 7.07106 5.22934 7.35922 5.22934 7.53553C5.22934 7.65133 5.28722 7.70921 5.40302 7.70921C5.51617 7.70921 5.60172 7.69475 5.6596 7.66579C5.71749 7.63683 5.75961 7.62237 5.78592 7.62237Z"
                                                fill="#628478"
                                                stroke="#628478"
                                                strokeWidth="0.3"
                                              />
                                            </svg>
                                          </Tooltip>
                                        </span>
                                      </span>
                                    }
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                  >
                                    <Input
                                      size="small"
                                      placeholder="Anmerkung"
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row
                                style={{
                                  marginBlock: 15,
                                  gap: 10,
                                  alignItems: 'end',
                                }}
                              >
                                <Col span={10}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 10,
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontSize: 13,
                                        color: '#595959',
                                        fontWeight: 500,
                                        display: 'block',
                                        width: '100%',
                                      }}
                                    >
                                      Hier können Sie Deals zeitlich
                                      beschränken. Freilassen, wenn dauerhaft
                                      gültig
                                    </label>
                                  </div>
                                  <Form.Item name={['dealPeriod']}>
                                    <RangePicker
                                      allowClear={true}
                                      size="small"
                                      format={dateFormat}
                                      locale={locale}
                                      // defaultValue={dealPeriod}
                                      style={{ width: '100%' }}
                                      className="picker-design-styl"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={3}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 6,
                                    }}
                                  >
                                    <Form.Item
                                      name={['dealValues', 'rollingDeal']}
                                      valuePropName="checked"
                                      initialValue={
                                        deal.rollingDeal === true ||
                                        deal.rollingDeal === 'true'
                                      }
                                      style={{ marginLeft: 0 }}
                                    >
                                      <Checkbox className="bigCheck">
                                        <h6 style={{ display: 'inline' }}>
                                          Rolling
                                        </h6>
                                      </Checkbox>
                                    </Form.Item>
                                    <Tooltip title="auswahlen wenn sich der Zeitraum jahrlich wiederholt.">
                                      <svg
                                        width="11"
                                        height="11"
                                        viewBox="0 0 11 11"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle
                                          cx="5.40039"
                                          cy="5.4"
                                          r="5"
                                          stroke="#628478"
                                          strokeWidth="0.8"
                                        />
                                        <path
                                          d="M6.59513 3.35132C6.53772 3.41147 6.47109 3.46211 6.39776 3.50132C6.3247 3.53798 6.24595 3.562 6.16486 3.57237C6.0833 3.58026 6.00564 3.56709 5.93197 3.53289C5.86092 3.49869 5.79909 3.45 5.74644 3.38684C5.6333 3.25525 5.57671 3.12237 5.57671 2.98816C5.57671 2.85395 5.59777 2.75394 5.63986 2.68816C5.68461 2.61973 5.73987 2.56446 5.80565 2.52237C5.93197 2.4408 6.05039 2.4 6.16092 2.4C6.27406 2.4 6.36091 2.40789 6.42144 2.42368C6.4846 2.43947 6.54249 2.46578 6.59513 2.50263C6.72406 2.58947 6.78855 2.69605 6.78855 2.82237C6.78855 2.94606 6.77014 3.04999 6.73329 3.13421C6.69909 3.21578 6.65301 3.28816 6.59513 3.35132ZM5.78592 7.62237C5.85435 7.62237 5.88855 7.66712 5.88855 7.75658C5.88855 7.875 5.83461 7.99737 5.72671 8.12368C5.56881 8.30788 5.35698 8.4 5.09118 8.4C4.78591 8.4 4.5767 8.2763 4.46355 8.02895C4.42145 7.9421 4.40039 7.83685 4.40039 7.71316C4.40039 7.58946 4.42145 7.45263 4.46355 7.30263C4.5083 7.15001 4.56223 6.99079 4.62539 6.825C4.69242 6.65361 4.76349 6.48382 4.83855 6.31579L5.04776 5.81842C5.20038 5.44737 5.27671 5.20263 5.27671 5.08421C5.27671 4.96579 5.26354 4.88817 5.23723 4.85132C5.21355 4.81184 5.18724 4.78159 5.15829 4.76053L5.07934 4.70526C5.05303 4.68685 5.03986 4.65527 5.03986 4.61053C5.03986 4.56316 5.05698 4.51841 5.09118 4.47632C5.12803 4.43422 5.1754 4.39737 5.23329 4.36579C5.35171 4.30525 5.48986 4.275 5.64776 4.275C6.0346 4.275 6.22802 4.3763 6.22802 4.57895C6.22802 4.81579 6.16619 5.08683 6.0425 5.3921C5.9188 5.69473 5.81355 5.93946 5.72671 6.12632L5.48986 6.67105C5.31618 7.07106 5.22934 7.35922 5.22934 7.53553C5.22934 7.65133 5.28722 7.70921 5.40302 7.70921C5.51617 7.70921 5.60172 7.69475 5.6596 7.66579C5.71749 7.63683 5.75961 7.62237 5.78592 7.62237Z"
                                          fill="#628478"
                                          stroke="#628478"
                                          strokeWidth="0.3"
                                        />
                                      </svg>
                                    </Tooltip>
                                  </div>
                                </Col>
                                <Col span={10}>
                                  <DirectoryTree
                                    checkable
                                    selectable={false}
                                    multiple
                                    showIcon={false}
                                    onCheck={(keys) => {
                                      dispatch(setTmpCourseId(deal._id));
                                      onCheckExisCourses(keys);
                                    }}
                                    onExpand={onExpand}
                                    treeData={treeDataMap}
                                    defaultCheckedKeys={deal.standardPricing}
                                    className="bg-change-style"
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row
                            style={{
                              alignItems: 'center',
                              justifyContent: 'end',
                              height: '100%',
                              gap: 10,
                            }}
                          >
                            <Button
                              type="primary"
                              htmlType="submit"
                              style={{
                                backgroundColor: '#1B392F',
                                borderColor: '#1F4D3D',
                                minWidth: 90,
                                height: 44,
                                fontSize: 15,
                                fontWeight: 500,
                                borderRadius: 10,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 8,
                                marginInlineStart: 'auto',
                              }}
                            >
                              Speichern
                            </Button>

                            <Popconfirm
                              title="Löschen Sie den Deal"
                              description="Wirklich löschen?"
                              icon={
                                <QuestionCircleOutlined
                                  style={{
                                    color: 'red',
                                  }}
                                />
                              }
                              onConfirm={() => deleteDeal(deal._id)}
                              onCancel={cancel}
                              okText="Bestätigen"
                              cancelText="Abbrechen"
                            >
                              <Button
                                className="btn-style-common"
                                style={{ minWidth: 90, height: 44 }}
                                size="small"
                              >
                                Löschen
                              </Button>
                            </Popconfirm>
                          </Row>
                        </Form>
                      );
                    }
                  })}
              </div>
            </div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default Sonstige;
